export default __webpack_public_path__ + "static/media/iban_description.9c8012b0.png";